<!-- <div class="row">
	<div class="col-lg-12">
	  <div class="ibox float-e-margins">
		<div class="ibox-content"> -->
<router-outlet></router-outlet>
<!-- </div>
	  </div>
	</div>
</div> -->
